export default function loadMediaFeatures() {
  const loaded = new Promise(resolve => {
    window.Shopify.loadFeatures(
      [
        {
          name: "model-viewer-ui",
          version: "1.0",
        },
        {
          name: "shopify-xr",
          version: "1.0",
        },
        {
          name: "video-ui",
          version: "1.0",
        },
      ],
      () => {
        resolve();
      }
    );
  });

  return loaded;
}
